import { render, staticRenderFns } from "./workShop.vue?vue&type=template&id=9e12e028&"
import script from "./workShop.vue?vue&type=script&lang=js&"
export * from "./workShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports